import { Component, Input } from '@angular/core';
import { APIReferenceDetailXMLSection } from 'src/app/model/section/api-references-details-xml-section';

@Component({
  selector: 'app-api-reference-details-xml-section',
  templateUrl: './api-reference-details-xml-section.component.html',
  styleUrls: ['./api-reference-details-xml-section.component.scss']
})
export class ApiReferenceDetailsXmlSectionComponent {
  @Input() isSubSection = false;
  @Input() pageName = '';
  @Input() apiReferenceDetailXMLSections: APIReferenceDetailXMLSection[] = [];

  constructor() {}
}
